import axios from 'axios';

// 1. CONFIGURACIÓN BASE
const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://10.208.0.60:8000', 
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000, 
});

// 2. INTERCEPTOR DE SOLICITUD (REQUEST) 🛡️
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 3. INTERCEPTOR DE RESPUESTA (RESPONSE) 🚨
api.interceptors.response.use(
    (response) => response, // Si todo sale bien, dejamos pasar la respuesta
    async (error) => {
        // Guardamos la petición original que acaba de fallar
        const originalRequest = error.config;

        // Si el error es 401 (No autorizado) y AÚN NO hemos intentado reintentar esta petición
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            
            // Marcamos esta petición para no entrar en un bucle infinito
            originalRequest._retry = true;

            try {
                const refreshToken = localStorage.getItem('refresh_token');
                
                if (!refreshToken) {
                    throw new Error("No hay refresh token disponible");
                }

                // ⚠️ CRÍTICO: Usamos 'axios.post' directamente, NO 'api.post'
                // Si usamos 'api.post', el interceptor atraparía su propio error y haríamos un bucle
                const response = await axios.post(`${api.defaults.baseURL}/api/token/refresh/`, {
                    refresh: refreshToken
                });

                // Si Django nos da una llave nueva, la guardamos
                const newAccessToken = response.data.access;
                localStorage.setItem('token', newAccessToken);

                // Actualizamos la cabecera de la petición original que falló y la VOLVEMOS a enviar
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return api(originalRequest);

            } catch (refreshError) {
                // Si esto falla, significa que el refresh_token de 8 horas también caducó, 
                // o el usuario fue bloqueado en el backend. AHORA SÍ lo pateamos al login.
                if (window.location.pathname !== '/login') {
                    console.warn("⚠️ Sesión expirada por completo. Redirigiendo al login...");
                    localStorage.removeItem('token');
                    localStorage.removeItem('refresh_token');
                    localStorage.removeItem('user_data');
                    window.location.href = '/login'; 
                }
                return Promise.reject(refreshError);
            }
        }
        
        // Si es otro error (como 500, 404, 403), lo dejamos pasar para que el frontend lo maneje
        return Promise.reject(error);
    }
);

export default api;